
import * as strapiRuntime$HPaGcmkEEt from '/home/runner/work/suwo/suwo/website/node_modules/@nuxt/image/dist/runtime/providers/strapi'
import * as ipxRuntime$8xrGFZ2iHT from '/home/runner/work/suwo/suwo/website/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['strapi']: { provider: strapiRuntime$HPaGcmkEEt, defaults: {"baseURL":"https://admin.suwo.nl/uploads/"} },
  ['ipx']: { provider: ipxRuntime$8xrGFZ2iHT, defaults: {} }
}
        